import React from 'react';
import { Grid, Typography, Button } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider, withStyles } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import TextField from '@material-ui/core/TextField';
import globalUseStyles from '../../styleHooks';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {FaCheckCircle} from 'react-icons/fa';
import contactClasses from './contactStyles';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);


function ContactFeatured() {
  const globalClasses = globalUseStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
<ThemeProvider theme={theme}>
    <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
        <Grid className={globalClasses.containerSmall} container >
            <Grid item xs={12} md={12}  >
                <Typography variant="h1">Contact us</Typography>
                <Typography variant="body1">Let’s talk about your challenge. Fill out the form below and someone from our team will be in touch with you shortly. </Typography>
            </Grid>
        <Grid item xs={12} md={8}  >
          <form fullWidth noValidate autoComplete="off">
            <div>
              <TextField
                id="standard-full-width"
                label="First Name"
                fullWidth
                rowsMax={1}
                style={{ paddingBottom: 30 }}
                /*value={value}
                onChange={handleChange}*/
              />
            </div>
            <div>
              <TextField
                id="standard-multiline-flexible"
                label="Last Name"
                fullWidth
                rowsMax={1}
                style={{ paddingBottom: 30 }}
                /*value={value}
                onChange={handleChange}*/
              />
            </div>
            <div>
              <TextField
                id="standard-full-width"
                label="Email"
                fullWidth
                style={{ paddingBottom: 30 }}
                /*value={value}
                onChange={handleChange}*/
              />
            </div>
            <div>
              <TextField
                id="standard-multiline-flexible"
                label="Message"
                multiline
                fullWidth
                rowsMax={8}
                style={{ paddingBottom: 30 }}
                /*value={value}
                onChange={handleChange}*/
              />
            </div>
            <Button className={'primaryButton'} variant="outlined" color="primary" onClick={handleClickOpen}>Send</Button>
          </form>
          <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>

        <DialogContent className={globalClasses.dialogBoxSuccess}>
        <FaCheckCircle className={globalClasses.iconSuccess}/>
          <Typography gutterBottom>
            Thank you for your message.  We are looking forward to speaking with you!  We will respond to your message within the next few days.
          </Typography>

            </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
Close          </Button>
        </DialogActions>
      </Dialog>

        </Grid>
        <Grid item xs={false} md={4}  />
      </Grid>
    </Container>
</ThemeProvider>
  );
};

export default ContactFeatured;